<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height=height viewBox="0 0 11.583 12">
        <g id="height" transform="translate(-2.615 -0.236)">
            <g id="Group_2500" data-name="Group 2500" transform="translate(2.274 -0.067)">
                <g id="Group_2499" data-name="Group 2499" transform="translate(0)">
                    <path id="Path_69855" data-name="Path 69855"
                          d="M392.778,49.907V42.8l.48.48.524-.525-1.375-1.375-1.375,1.375.525.525.48-.48v7.112l-.48-.48-.525.525,1.375,1.375,1.375-1.375-.524-.525Z"
                          transform="translate(-381.858 -40.048)" fill="#799cfb"/>
                    <rect id="Rectangle_683" data-name="Rectangle 683" width="5" height="1"
                          transform="translate(0.341 0.303)" fill="#799cfb"/>
                    <rect id="Rectangle_684" data-name="Rectangle 684" width="6" height="1"
                          transform="translate(2.341 2.303)" fill="#799cfb"/>
                    <rect id="Rectangle_685" data-name="Rectangle 685" width="8" height="1"
                          transform="translate(0.341 4.303)" fill="#799cfb"/>
                    <rect id="Rectangle_686" data-name="Rectangle 686" width="8" height="1"
                          transform="translate(0.341 9.303)" fill="#799cfb"/>
                    <rect id="Rectangle_687" data-name="Rectangle 687" width="6" height="1"
                          transform="translate(2.341 7.303)" fill="#799cfb"/>
                    <rect id="Rectangle_688" data-name="Rectangle 688" width="6" height="1"
                          transform="translate(2.341 11.303)" fill="#799cfb"/>
                    <rect id="Rectangle_689" data-name="Rectangle 689" height="1" transform="translate(8.341 0.303)"
                          fill="#799cfb"/>
                    <rect id="Rectangle_690" data-name="Rectangle 690" width="1" height="1"
                          transform="translate(6.341 0.303)" fill="#799cfb"/>
                </g>
            </g>
        </g>
    </svg>

</template>

<script>
    export default {
        name: "IHeight",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
